module.exports = __webpack_public_path__ + "img/th.d6d46567.svg";